module.exports = __webpack_public_path__ + "static/media/2-1.0f26f886.png";